export default "__VITE_ASSET__CQYMZDcZ__"